import React from "react";

/**
 * EyesLoader – simple CSS eyes loader.
 * Props:
 *  - size: overall width in px (default 64)
 */
export default function EyesLoader({ size = 64 }) {
  return (
    <div
      className="eyes-loader"
      style={{ "--eyes-size": `${size}px` }}
      role="status"
      aria-label="Loading"
    >
      <span className="eye" />
      <span className="eye" />
    </div>
  );
}
